// extracted by mini-css-extract-plugin
export default {"wrapper":"ResearchHeader_wrapper__LNMJ6"};